import { object, string, number, array } from 'yup';

export const appsCreateStep1ValidationSchema = object().shape({
  name: string().required('Name is required').max(48),
  description: string().required('Description is required').max(255),
  dau: number().min(1, 'DAU is required').required('DAU is required'),
  mau: number().min(1, 'MAU is required').required('MAU is required'),
  categories: array().of(object()).min(1, 'At least one category should be selected')
});

export const appsCreateStep2ValidationSchema = object().shape({
  url: string()
    .matches(
      /^(https?:\/\/(?:localhost|\d{1,3}(?:\.\d{1,3}){3}|[a-zA-Z0-9.-]+)(?::\d+)?(?:\/[^\s]*)?)$/,
      'Invalid URL format, must start with http or https'
    )
    .required('App URL is required'),
  claimNotificationUrl: string()
    .matches(
      /^(https?:\/\/(?:localhost|\d{1,3}(?:\.\d{1,3}){3}|[a-zA-Z0-9.-]+)(?::\d+)?(?:\/[^\s]*)?)$/,
      'Invalid URL format, must start with http or https'
    )
    .required('Claim Notification URL is required')
});

export const editAppValidationSchema = object().shape({
  name: string().required('Name is required').max(48),
  description: string().max(255),
  dau: number().required('DAU is required'),
  mau: number().required('MAU is required'),
  categories: array().of(object()).min(1, 'At least one category should be selected')
});
